

import { defineComponent, PropType } from 'vue';
import { Tournament } from '@/views/interfaces/entities.ts';
import { defaultPlayer, Player } from '@/views/interfaces/entities.ts';

export default defineComponent({
    name: 'ended-tournament-card',
    props: {
        tournament: {
            type: Object as PropType<Tournament>,
            required: true,
        },
        player: {
            type: Object as PropType<Player>,
            default: defaultPlayer,
        }
    },
    computed:{
        endDate(){
            const timestamp: number = this.tournament.endMatch * 1000;
            const end: Date = new Date(timestamp);
            return  `${end.getMonth()+1}/${end.getDate()}/${end.getFullYear()}`
        },
    }

});
